export const appSettingsAppGroupIdApiKeysApiKeyIdMetadata =
  "/app_settings/:app_group_id/api_keys/:api_key_id/metadata";
